import { render, staticRenderFns } from "./WhiteBoard.vue?vue&type=template&id=71d36b9e&scoped=true"
import script from "./WhiteBoard.vue?vue&type=script&lang=js"
export * from "./WhiteBoard.vue?vue&type=script&lang=js"
import style0 from "./WhiteBoard.vue?vue&type=style&index=0&id=71d36b9e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d36b9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71d36b9e')) {
      api.createRecord('71d36b9e', component.options)
    } else {
      api.reload('71d36b9e', component.options)
    }
    module.hot.accept("./WhiteBoard.vue?vue&type=template&id=71d36b9e&scoped=true", function () {
      api.rerender('71d36b9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/WhiteBoard/Modal/WhiteBoard.vue"
export default component.exports